/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckMark/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import Check from 'DesignSystem/Svgs/Check/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CheckMark({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Answer/CheckMark"
  
}) {
let answerAnswerValueValueData = fromData.useDataFormat({ viewPath,
context: 'answer',
path: 'answerValue',
format: fromHelpers.isAnswered,
})
let dtCheckStrokeBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Check.stroke.brand.base'
        })
let answerValueData = fromData.useDataFormat({ viewPath,
context: 'answer',
format: fromHelpers.isSkipped,
})
let answerAnswerValueValueData1 = fromData.useDataFormat({ viewPath,
context: 'answer',
path: 'answerValue',
format: fromHelpers.isUnAnswered,
})
let dtCheckStrokeBrandDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Check.stroke.brand.disabled'
        })
  return (<React.Fragment
>
<fromFlow.When is={answerAnswerValueValueData}>
<Check
  viewPath={`${viewPath}/Check`}
 data="answer.answerValue"
 format="helpers.js isAnswered"
 height={25}
 marginLeft={15}
 marginRight={10}
 stroke={dtCheckStrokeBrandBase}
 width={25}
/>
</fromFlow.When>
<div
  data-testid="CheckMark.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={answerValueData}>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 data="answer"
 format="helpers.js isSkipped"
 height={25}
 marginLeft={15}
 marginRight={10}
 stroke={dtCheckStrokeBrandBase}
 width={25}
 rotate="90deg"
/>
</fromFlow.When>
</div>
<div
  data-testid="CheckMark.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<fromFlow.When is={answerAnswerValueValueData1}>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 data="answer.answerValue"
 format="helpers.js isUnAnswered"
 height={20}
 marginLeft={15}
 marginRight={10}
 stroke={dtCheckStrokeBrandDisabled}
 width={20}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}